import React from "react"
import PropTypes from "prop-types"

import { Link } from "gatsby"

import PostLinkTransformer from "./parsers/PostLinkTransformer"

import { Trans } from "gatsby-plugin-react-i18next"

import * as suggestedContentSectionStyles from "../styles/SuggestedContentSection.module.css"

const businessUnitLabel = content => {
  const categoryList = content.categories

  const categories = categoryList.map(t => t.toLowerCase())

  if (categories.includes(`consulting`)) return `Business Knowledge Hub`
  if (categories.includes(`education`)) return `Education Knowledge Hub`
  if (categories.includes(`technical`)) return `Technology Knowledge Hub`

  return `Business Knowledge Hub`
}

export default function SuggestedContentSection(props) {
  const { content } = props

  return (
    <div
      className={props.withWrapper ? suggestedContentSectionStyles.wrapper : ``}
    >
      <div className={`row ${suggestedContentSectionStyles.heading}`}>
        <div className={`col-12`}>
          <h2 className={`${suggestedContentSectionStyles.title}`}>
            <Trans>Suggested Content</Trans>
          </h2>
        </div>
      </div>

      <div
        className={`row ${suggestedContentSectionStyles.suggestedContentResults}`}
      >
        {content &&
          content.map((c, idx) => (
            <div
              key={idx}
              className={`col-4 ${suggestedContentSectionStyles.holder}`}
            >
              <h2 className={`${suggestedContentSectionStyles.businessUnit}`}>
                <Trans>{businessUnitLabel(c)}</Trans>
              </h2>
              <hr className={`${suggestedContentSectionStyles.divider}`} />
              <h4 className={`${suggestedContentSectionStyles.title}`}>
                {c.title}
              </h4>
              <p className={`${suggestedContentSectionStyles.content}`}>
                {c.synopsis}
              </p>
              <Link
                className={`${suggestedContentSectionStyles.suggestedContentCta}`}
                to={PostLinkTransformer(
                  c.link,
                  props.pageContext.language,
                  props.pageContext.i18n.defaultLanguage,
                  props.pageContext.i18n.languages
                )}
              >
                <Trans>Read More</Trans>
              </Link>
            </div>
          ))}
      </div>
    </div>
  )
}

SuggestedContentSection.defaultProps = {
  withWrapper: true,
}

SuggestedContentSection.propTypes = {
  withWrapper: PropTypes.bool,
  content: PropTypes.array.isRequired,
}
